import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { FGrid, FItem } from "ferrum-design-system";
import tickIcon from "../../../../assets/img/ic-tick-circle.png";
import animateLoadingIcon from "../../../../assets/gif/MultiSwap-anima-loading-infinite.gif";
import circleIcon from "../../../../assets/ms-new-images/icons/circleIcon.png";

export const CategorizationProgressBar = ({ progressBar }: any) => {
  return (
    <div>
      <FGrid className="progressbar">
        <ProgressBar
          width={420}
          height={3}
          percent={progressBar}
          filledBackground="#D9B373"
        >
          <Step transitionDuration={1000} transition="scale">
            {({ accomplished }) => (
              <img
                width="15"
                height={15}
                src={
                  accomplished
                    ? progressBar > 0
                      ? tickIcon
                      : animateLoadingIcon
                    : circleIcon
                }
              />
            )}
          </Step>
          <Step transitionDuration={1000} transition="scale">
            {({ accomplished }) => (
              <img
                width="15"
                height={15}
                src={
                  accomplished
                    ? progressBar > 40
                      ? tickIcon
                      : animateLoadingIcon
                    : circleIcon
                }
              />
            )}
          </Step>
          <Step transitionDuration={1000} transition="scale">
            {({ accomplished }) => (
              <img
                width="15"
                height={15}
                src={
                  accomplished
                    ? progressBar > 0
                      ? tickIcon
                      : animateLoadingIcon
                    : circleIcon
                }
              />
            )}
          </Step>
          <Step transitionDuration={1000} transition="scale">
            {({ accomplished }) => (
              <img
                width="15"
                height={15}
                src={
                  accomplished
                    ? progressBar > 0
                      ? tickIcon
                      : animateLoadingIcon
                    : circleIcon
                }
              />
            )}
          </Step>
        </ProgressBar>
      </FGrid>
      <FItem display={"flex"} className="custom-step-bar">
        <p
          className="custom-step-bar-text"
          style={{
            color: progressBar > 0 ? "#FFFFFF" : "gray",
          }}
        >
          Checking Networks
        </p>
        <p
          className="custom-step-bar-text f-mr-1"
          style={{
            color: progressBar > 33 ? "#FFFFFF" : "gray",
          }}
        >
          Categorization
        </p>
        <p
          className="custom-step-bar-text f-mr--5"
          style={{
            color: progressBar > 66 ? "#FFFFFF" : "gray",
          }}
        >
          Source Network
        </p>
        <p
          className="custom-step-bar-text f-mr--3"
          style={{
            color: progressBar > 99 ? "#FFFFFF" : "gray",
          }}
        >
          Destination Network
        </p>
      </FItem>
    </div>
  );
};
